import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from "@angular/router";
import { TranslatePipe } from '@ngx-translate/core';

import { Navlink } from "../../ui/navlink/navlink";
import { Sidebar } from '../../../core/services/sidebar';


@Component({
  selector: 'app-sidebar',
  imports: [Navlink, CommonModule, RouterLink, RouterLink, TranslatePipe],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class SidebarLeft {
  constructor(public sidebarService: Sidebar) { }
  
}
